var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"annotation-info"},[_c('AnnotationFormTexte',{staticClass:"mb-2",attrs:{"element":_vm.element,"format":"textarea"}}),_c('AnnotationForme',{attrs:{"element":_vm.element,"mode":"stroke"}}),_c('AnnotationForme',{attrs:{"element":_vm.element,"mode":"fill"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }